import React, { useState, useEffect } from 'react';
import {
  Grid,
  Typography,
  Card,
} from '@mui/material';
import DefaultNavbar from "examples/Navbars/DefaultNavbar";
import routes from "trainerRoutes";
import editRoutes from "trainingCompanyEditRoutes";
import Container from "@mui/material/Container";
import Logo from "assets/images/skill2.png";
import CompanyIcon from "assets/images/companyicon.png";
import Expectation from "assets/images/team_3082743.png";
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import MKButton from "components/MKButton";
import { LocationOn, AttachMoney } from '@mui/icons-material';
import MKTypography from "components/MKTypography";
import { useNavigate } from 'react-router-dom';
import '../../../styles.css';
import IdleTimeOutHandler from "pages/IdleTimeHandler/IdleTimeOutHander";

const Page = () => {
  // const styles = {
  //   gridItem: {
  //     border: '1px double #ccc',
  //     borderRadius: '30px',
  //     padding: '16px',
  //     marginBottom: '16px',
  //     boxShadow: '0px 2px 6px rgba(0, 0, 0, 0.1)',
  //     width: '500px',
  //     backgroundColor: ({ palette: { white }, functions: { rgba } }) => rgba(white.main, 1.0), backdropFilter: "saturate(200%) blur(30px)", boxShadow: ({ boxShadows: { xxl } }) => xxl,
  //   },
  //   trainingInfo: {
  //     display: 'flex',
  //     flexDirection: 'column',
  //   },
  //   trainingName: {
  //     // marginTop: '10px',
  //     marginBottom: '8px',
  //     fontSize: 'medium',
  //     color: 'rgb(60, 150, 190)',
  //   },
  //   gridContent: {
  //     padding: '8px',
  //   },
  // };
  const [trainingCompanyProfileCreate, setTrainingCompanyProfileCreate] = useState(false);
  const [activeTrainingDetails, setActiveTrainingDetails] = useState([]);
  const [trainingDetails, setTrainingDetails] = useState([]);
  const [postedTrainingDetails, setPostedTrainingDetails] = useState([]);
  const [appliedTrainingDetails, setAppliedTrainingDetails] = useState([]);
  const [completedTrainingDetails, setCompletedTrainingDetails] = useState([]);
  const [cancelledTrainingDetails, setCancelledTrainingDetails] = useState([]);

  useEffect(() => {
    let id = localStorage.getItem("userId");
    console.log(id);
    let display = "nocard";
    fetch(`${process.env.REACT_APP_API_URL}/api/dashboard-active-training/${id}/${display}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + localStorage.getItem('token'),
      },
    })
      .then((resp) => resp.json())
      .then((data) => {
        console.log("data111111122222222222", data);

        if (data && data[0] && data[0].apply_data && data[0].apply_data.length > 0) {
          data[0].apply_data.forEach((applyTrainings) => {
            setAppliedTrainingDetails((prevDetails) => [...prevDetails, applyTrainings]);
          })
        }

        if (data && data[0] && data[0].completed_training_data && data[0].completed_training_data.length > 0) {
          data[0].completed_training_data.forEach((completed_trainings) => {
            setCompletedTrainingDetails((prevDetails) => [...prevDetails, completed_trainings]);
          })
        }

        if (data && data[0] && data[0].canceled_training_array && data[0].canceled_training_array.length > 0) {
          data[0].canceled_training_array.forEach((cancelled_trainings) => {
            setCancelledTrainingDetails((prevDetails) => [...prevDetails, cancelled_trainings]);
          })
        }

        if (data && data[0] && data[0].posted_training_array && data[0].posted_training_array.length > 0) {
          data[0].posted_training_array.forEach((posted_trainings) => {
            setPostedTrainingDetails((prevDetails) => [...prevDetails, posted_trainings]);
          })
        }

      })
      .catch((error) => {
        console.error(error);
      });
  }, [localStorage.getItem("userId")]);

  console.log("postedTrainingDetails", postedTrainingDetails);

  const navigate = useNavigate();

  const onMoreDetailsClick = (training) => {
    console.log("training", training.id);
    navigate(`/app/activetrainingmoredetails/${training.id}/`);
  };

  const onEditClick = (training) => {
    console.log("training", training.id);
    navigate(`/app/edittrainingpost/${training.id}/`);
  };

  const renderTrainerCards = (trainers) => {
    return trainers.map((trainer, index) => (
      <Grid item xs={6} key={trainer.id} >
        <div className="gridItemSeeMore">
          <div className="gridContentSeeMore">
            <div className="trainingInfo">
              <Typography variant="subtitle1" className="trainingNameSeeMore"><strong>{trainer[0].trainingName}</strong></Typography>
              <Typography style={{ fontSize: 'medium' }}>
                <span style={{ display: 'flex', alignItems: 'center' }}>
                  <img src={Logo} alt="Skills Logo" style={{ whiteSpace: 'nowrap', marginRight: '5px', width: '20px', height: '20px' }} /> {trainer[0].displaySkills}
                </span>
              </Typography>
              <Typography style={{ fontSize: 'medium' }}>
                <span style={{ display: 'flex', alignItems: 'center' }}>
                  <img src={CompanyIcon} alt="Company Icon" style={{ marginRight: '5px', width: '20px', height: '20px' }} />{trainer[0].trainingCompanyName}
                </span>
              </Typography>
              <Typography style={{ fontSize: 'medium' }}>
                <span style={{ display: 'flex', alignItems: 'center' }}>
                  <LocationOn style={{ marginRight: '5px' }} /> {trainer[0].trainingMode}
                  {trainer[0].trainingMode === 'Classroom' ? ` | ${trainer[0].trainingLocations}` : ''}
                </span>
              </Typography>
              <Typography style={{ fontSize: 'medium' }}>
                <span style={{ display: 'flex', alignItems: 'center' }}>
                  {trainer[0].currency}&nbsp;{trainer[0].totalTrainingBudget} |&nbsp;<img src={Expectation} alt="Expectation Logo" style={{ marginRight: '5px', width: '20px', height: '20px' }} /> {trainer[0].trainingExpectation}
                </span>
              </Typography>
              <Typography style={{ fontSize: 'medium' }}>
                <span style={{ display: 'flex', alignItems: 'center' }}>
                  <CalendarMonthIcon style={{ marginRight: '5px' }} /> {trainer[0].expectedStartDate}
                </span>
              </Typography>
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '10px' }}>
              <MKButton variant="gradient" color="info" size="small" onClick={() => onMoreDetailsClick(trainer[0])} style={{ padding: '5px 10px', alignSelf: 'flex-start' }}>Details</MKButton>
              <MKButton variant="gradient" color="info" size="small" onClick={() => onEditClick(trainer[0])} style={{ padding: '5px 10px', alignSelf: 'flex-end' }}>Edit</MKButton>
            </div>
          </div>
        </div>
      </Grid>
    ));
  };


  return (
    <>
      <IdleTimeOutHandler />
      <DefaultNavbar
        routes={trainingCompanyProfileCreate ? routes : editRoutes}
        sticky
      />
      <Card
        sx={{
          minHeight: '101vh',
          height: 'auto',
          p: 2,
          mx: { xs: 2, lg: 3 },
          mt: -8,
          mb: 4,
          // backgroundColor: ({ palette: { white }, functions: { rgba } }) => rgba(white.main, 0.8),
          backdropFilter: "saturate(200%) blur(30px)",
          boxShadow: ({ boxShadows: { xxl } }) => xxl,
        }}
      >
        <Container>
          <Grid container>
            <Grid item xs={12} style={{ marginTop: "150px" }}>
              <div style={{ display: 'flex', flexDirection: 'column' }}>
                <Grid container spacing={2} style={{ marginBottom: "10px" }}>
                  <Grid item xs={12} style={{ display: 'flex' }}>
                    <MKTypography style={{ whiteSpace: 'nowrap' }} variant="h4" color="text">
                      <span style={{ color: 'black' }}>Posted</span>{' '}
                      <span style={{ color: '#2e1114' }}>Trainings</span>
                    </MKTypography>
                  </Grid>
                </Grid>

                {postedTrainingDetails.length === 0 ? (
                  <span style={{ marginLeft: "35px", marginBottom: "20px", fontSize: 'medium' }}>No Trainings has been posted yet</span>
                ) : (
                  ""
                )}

                {postedTrainingDetails.length === 0 ? (
                  ""
                ) : (
                  <Grid container spacing={2}>
                    {renderTrainerCards(postedTrainingDetails)}
                  </Grid>
                )}

              </div>
            </Grid>
          </Grid>
        </Container>
      </Card>
    </>
  );
};

export default Page;